import { render, staticRenderFns } from "./ThinkMoneyLogo.vue?vue&type=template&id=7bd0ce1a&scoped=true"
import script from "./ThinkMoneyLogo.vue?vue&type=script&lang=js"
export * from "./ThinkMoneyLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd0ce1a",
  null
  
)

export default component.exports